import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ROUTES } from '../config/api';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [newWeight, setNewWeight] = useState('');
  const [weightDate, setWeightDate] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const { data } = await axios.get(API_ROUTES.USER_PROFILE);
      setUserData(data.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Une erreur est survenue');
    }
  };

  const handleWeightSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_ROUTES.USER_WEIGHT, {
        weight: newWeight,
        date: weightDate || new Date().toISOString()
      });

      fetchUserData();
      setNewWeight('');
      setWeightDate('');
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Une erreur est survenue');
    }
  };

  if (!userData) {
    return <div className="dashboard-container">Chargement...</div>;
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Tableau de Bord</h1>
        {error && <div className="error-message">{error}</div>}
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2 className="card-title">Informations Personnelles</h2>
          <div className="info-item">
            <strong>Nom d'utilisateur:</strong> {userData.username}
          </div>
          <div className="info-item">
            <strong>Email:</strong> {userData.email}
          </div>
          <div className="info-item">
            <strong>Poids actuel:</strong> {userData.currentWeight} kg
          </div>
          <div className="info-item">
            <strong>Poids cible:</strong> {userData.targetWeight} kg
          </div>
        </div>

        <div className="dashboard-card">
          <h2 className="card-title">Mettre à jour le poids</h2>
          <form onSubmit={handleWeightSubmit} className="weight-form">
            <div className="form-group">
              <input
                type="number"
                value={newWeight}
                onChange={(e) => setNewWeight(e.target.value)}
                placeholder="Nouveau poids (kg)"
                className="form-input"
                step="0.1"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="date"
                value={weightDate}
                onChange={(e) => setWeightDate(e.target.value)}
                max={new Date().toISOString().split('T')[0]}
                className="form-input"
                placeholder="Date de la pesée"
              />
              <small className="form-help">Si non renseignée, la date du jour sera utilisée</small>
            </div>
            <button type="submit" className="submit-button">
              Ajouter la mesure
            </button>
          </form>
        </div>

        <div className="dashboard-card">
          <h2 className="card-title">Historique du poids</h2>
          <div className="weight-history">
            {userData.weightHistory?.sort((a, b) => new Date(b.date) - new Date(a.date)).map((entry, index) => (
              <div key={index} className="weight-item">
                <span className="weight-date">
                  {new Date(entry.date).toLocaleDateString('fr-FR')}
                </span>
                <span className="weight-value">{entry.weight} kg</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 